// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1NliF","inner":"Footer_inner__szq2S"};